<template>
<div>
	<!-- 批量搜索账户ID -->
	<a-modal
	      :title="`批量搜索账户ID（${pl_text_content.length}）`"
	      :visible="pl_account_visible"
		  cancelText="取消"
		  okText="确认" 
	      @ok="plAccountOk"
	      @cancel="plAccountCancel"
	    >
		<div style="display: flex;align-items: center;margin-bottom: 15px;">
			<a-input @paste="plAccPasting" :value="pl_acc_input" style="width:400px;" placeholder="请粘贴推广账户ID，每个ID一行" />
			<a-button @click="clearPlAcc" size="small" style="margin-left: 10px;">清空</a-button>
		</div>
		<div style="max-height: 500px;overflow-y: auto;margin-bottom: 15px;">
			<div v-for="(item,index) in pl_text_content" :key="index+'a'" 
			style="margin-bottom:10px;display: flex;align-items: center;">
				<a-input :value="item" @change="textInput($event,index)" placeholder="" style="width:400px;" />
				<a-icon @click="delPlId(index)" style="font-size:16px;margin-left:10px;cursor: pointer;" type="close-circle" />
			</div>
		</div>
	</a-modal>
</div>
</template>

<script>
export default {
	name: 'plSearchID',
	props: [],
	data(){
		return {
			// 批量搜索账户ID
			pl_account_visible: false, // 批量搜索账户ID
			pl_text_content: [], // 批量粘贴过来，分隔过后的数据
			pl_acc_input: "", 
		}
	},
	methods: {
		// 批量搜索账户ID
		plAccountID(){
			this.pl_account_visible = true
		},
		plAccountOk(){
			// this.searchButton('批量账户ID')
			this.$emit('get-pl-id', this.pl_text_content)
			
			this.plAccountCancel()
		},
		plAccountCancel(){
			this.pl_account_visible = false
			this.pl_text_content = []
		},
		// 清空按钮
		clearPlAcc(){
			this.pl_text_content = []
		},
		// 输入框变化的回调
		plAccInput(e){
			// console.log("输入框变化的回调",e.target.value)
			let text_ = JSON.parse(JSON.stringify(e.target.value))
			this.pl_acc_input = ""
			// console.log("text_",text_)
			// console.log("text_",text_.split(/[(\r\n\t\s)\r\n\t\s]+/))
			this.pl_text_content = text_.split(/[(\r\n\t\s)\r\n\t\s]+/)
		},
		// 删除某个ID
		delPlId(index){
			this.pl_text_content.splice(index,1)
		},
		
		// 单个ID输入框
		textInput(e,index){
			// console.log("单个ID输入框",e.target.value)
			// this.pl_text_content[index] = e.target.value
			this.$set(this.pl_text_content, index, e.target.value)
			// console.log("pl_text_content",this.pl_text_content)
		},
		// 粘贴事件
		plAccPasting(e){
			console.log("粘贴",e.clipboardData.getData('Text'))
			let aaa = e.clipboardData.getData('Text').replace(/^\s+/,'')
			// let text_ = JSON.parse(JSON.stringify(aaa))
			// console.log("text_",text_);
			this.pl_acc_input = ""
			let ddd = aaa.split(/[\r\n\t\s]+/)
			
			let ttt = this.pl_text_content || []
			ddd.filter(item=>{
				if(item != ''){
					ttt.push(item)
				}
			});
			
			this.pl_text_content = ttt
			// console.log("pl_text_content",this.pl_text_content);
		}
	}
}
</script>

<style>
</style>